<template>
    <section>
        <canvas ref="barChart"></canvas>
    </section>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'Histogram',
        props: ['chartData'],
        data () {
            return {
                barChart: null,
                min: -1,
                max: 1
            }
        },
        methods: {
            color (value) {
                // 50, 94.9, 92,4
                // 228, 70.9, 20.2
                if (this.max - this.min === 0) {
                    // return 'hsl(136 ,60%, 57%)'
                    return this.hslToRgb(0, 0.60, 0.57)
                }
                const h = Math.floor((((value - this.min) / (this.max - this.min))) * 136)
                // return `hsl(${h} ,60%, 57%)`
                return this.hslToRgb(h / 360, 0.60, 0.57)
            },
            /**
             * Converts an HSL color value to RGB. Conversion formula
             * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
             * Assumes h, s, and l are contained in the set [0, 1] and
             * returns r, g, and b in the set [0, 255].
             *
             * @param   {number}  h       The hue
             * @param   {number}  s       The saturation
             * @param   {number}  l       The lightness
             * @return  {Array}           The RGB representation
             */
            hslToRgb (h, s, l) {
                let r, g, b

                if (s === 0) {
                    r = g = b = l // achromatic
                } else {
                    const hue2rgb = (p, q, t) => {
                        if (t < 0) t += 1
                        if (t > 1) t -= 1
                        if (t < 1 / 6) return p + (q - p) * 6 * t
                        if (t < 1 / 2) return q
                        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
                        return p
                    }

                    const q = l < 0.5 ? l * (1 + s) : l + s - l * s
                    const p = 2 * l - q
                    r = hue2rgb(p, q, h + 1 / 3)
                    g = hue2rgb(p, q, h)
                    b = hue2rgb(p, q, h - 1 / 3)
                }

                return [
                    Math.round(r * 255).toString(16),
                    Math.round(g * 255).toString(16),
                    Math.round(b * 255).toString(16)
                ]
            },
            drawBarChart () {
                const ctx = this.$refs.barChart
                this.barChart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: this.chartData.map(x => x[0]),
                        datasets: [
                            {
                                label: '',
                                backgroundColor: this.chartData.map(x => `#${this.color(x[0]).join('')}`),
                                borderColor: this.chartData.map(x => `#${this.color(x[0]).join('')}`),
                                data: this.chartData.map(x => x[1])
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItems, data) => {
                                    return tooltipItems.yLabel
                                }
                            }
                        },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    // Include a dollar sign in the ticks
                                    callback: (value, index, values) => {
                                        if (index === 0) {
                                            return 'Very negative'
                                        }
                                        if (value === 0) {
                                            return 'Neutral'
                                        }
                                        if (index === values.length - 1) {
                                            return 'Very Positive'
                                        }
                                        return ''
                                    },
                                    min: this.min,
                                    max: this.max,
                                    autoSkip: false
                                },
                                gridLines: {
                                    display: false,
                                    zeroLineWidth: 4
                                },
                                barPercentage: 1.0,
                                categoryPercentage: 1.0
                            }],
                            yAxes: [{
                                ticks: {
                                    min: 0,
                                    suggestedMin: 0
                                }
                            }]
                        }
                    }
                })
            }
        },
        watch: {
            chartData (data) {
                this.drawBarChart()
            }
        }
    }
</script>

<style scoped>

</style>
